<template>
    <form-row title="Have You Received Your Inspection Report?">
        <div class="flex flex-col sm:flex-row flex-1 sm:items-center">
            <input-radio-boolean
                name="inspection_report_received"
                v-model="inspection_report_received"
                true="Yes"
                false="No"
                :read_only="read_only"
            />

            <input-date
                v-if="inspection_report_received"
                class="mt-4 sm:ml-12 sm:-mt-2 sm:-mb-2 flex flex-1 items-center sm:justify-end"
                label="Date Received:"
                :value="inspection.inspection_report_received_at"
                name="inspection_report_received_at"
                :read_only="read_only"
            />
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        inspection: {},
        read_only: { default: false },
    },

    data() {
        return {
            inspection_report_received: this.inspection.inspection_report_received,
        }
    },
}
</script>
